/** TagsView「只保留当前页签」查询参数（新窗口进入工作台时使用）。 */
export const ADMIN_SOLO_TAGS_QUERY_KEY = "fm_solo_tags";

/** 把任意 search 规范成 `?a=b` 或 undefined。 */
function normalizeSearch(search: string | undefined): string | undefined {
  if (!search || search === "?") {
    return undefined;
  }
  return search.startsWith("?") ? search : `?${search}`;
}

/** 在跳转地址上附加 solo 标记；已有则保持为 1。 */
export function withAdminSoloTagsQuery(path: string): string {
  const questionIndex = path.indexOf("?");
  const pathname = questionIndex >= 0 ? path.slice(0, questionIndex) : path;
  const params = new URLSearchParams(questionIndex >= 0 ? path.slice(questionIndex + 1) : "");
  params.set(ADMIN_SOLO_TAGS_QUERY_KEY, "1");
  const query = params.toString();
  return `${pathname}?${query}`;
}

/**
 * 读取并剥离 solo 标记。
 * @returns solo 是否生效；search 为去掉标记后的 query（含前导 ?，无参数时为 undefined）。
 */
export function takeAdminSoloTagsFlag(search: string | undefined): {
  solo: boolean;
  search: string | undefined;
} {
  const normalized = normalizeSearch(search);
  if (!normalized) {
    return { solo: false, search: undefined };
  }
  const params = new URLSearchParams(normalized.slice(1));
  const solo = params.get(ADMIN_SOLO_TAGS_QUERY_KEY) === "1";
  if (!solo) {
    return { solo: false, search: normalized };
  }
  params.delete(ADMIN_SOLO_TAGS_QUERY_KEY);
  const next = params.toString();
  return { solo: true, search: next ? `?${next}` : undefined };
}
